import {captureException} from '@sentry/react'
import axios, {parseAxiosPromise} from '@/axiosInstance.ts'
import {
    AvailableMergedReportMonths,
    MergedReportExportRequest,
    MergedReportExportResponse
} from '@/features/accesses/activity-report/types'

/* GET the periods ('MM-YYYY') exportable as a merged report — only months for which BOTH the
   domiciliary and outpatient sector reports exist. Server-sorted most-recent-first; empty ⇒ none. */
export const httpGetMergedReportAvailableMonths = () =>
    parseAxiosPromise({
        axiosPromise: axios.get('v1/activity-reports/merged/available-months'),
        responseShape: AvailableMergedReportMonths,
        onZodError: captureException
    })

/* POST enqueue the unified CSV export (async) → 202 { exportJob }. A synchronous guard returns
   409 `merged-report-period-not-ready` when the month lacks a sector; otherwise the job is tracked
   through the shared async-export machinery (socket + exports history). */
export const httpExportMergedReportByMonth = (payload: MergedReportExportRequest) =>
    parseAxiosPromise({
        axiosPromise: axios.post('v1/activity-reports/merged/export-by-month', payload),
        responseShape: MergedReportExportResponse,
        onZodError: captureException
    })
